export type ExpiringItem<T> = {
    value: T;
    expiry: number;
};

export const LocalStorageHelper = {
  setItemWithExpiry<T>(key: string, value: T, expiryInDays: number): void {
    const expiryTime = Date.now() + (expiryInDays * 24 * 60 * 60 * 1000); // Convert to milliseconds
    const expiringItem: ExpiringItem<T> = { value, expiry: expiryTime };
    localStorage.setItem(key, JSON.stringify(expiringItem));
  },
  getItemWithExpiry<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (item) {
      const expiringItem: ExpiringItem<T> = JSON.parse(item);
      if (Date.now() < expiringItem.expiry) {
        return expiringItem.value;
      } else {
        localStorage.removeItem(key);
      }
    }
    return null;
  },
};

